import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import VueSweetalert2 from 'vue-sweetalert2';
import VueScrollactive from 'vue-scrollactive';
import VueHead from 'vue-head'

Vue.use(VueHead);
Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
Vue.use(VueScrollactive);

var myApp = new Vue({
    data:{
        title:'Mr Sandman',
        description:'Flooring Specialist operating in the Northland area',
        version:'0.01 Beta',
        rootURL: 'https://mr-sandman-nz.firebaseapp.com',
        devMode: false,
        developer: {
            company:'IT Trail',
            name:'Hayden Trail'
        },
        customer:{
            name: 'Mr Sandman',
            phone:'027 4909 328',
            email:'rangi.weir73@gmail.com'
        }
    }
});

myApp.install = function(){
    Object.defineProperty(Vue.prototype, '$myApp', {get () { return myApp }})
};
Vue.use(myApp);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

